export default "__VITE_ASSET__fHkeEFwK__"